const outStandingBalance = {
    list:{
        providersOutstandingBalance:' قائمة المبلغ المستحق لمقدمي الخدمة',
        searchPlaceholder:'ابحث بواسطة اسم مقدم الخدمة او رقم مقدم الخدمة',
        providerNumber: 'رقم مقدم الخدمة',
        providerName: 'اسم مقدم الخدمة',
        outstandingBalance: 'المبلغ المستحق',
    },
    details:{
        transactions: 'المعاملات',
        settlements: 'التسويات',
        providerOutstandingDetails:'المبالغ المستحقة ل',
        cash: 'نقدي',
        online: 'دفع إلكتروني',
        admin_resolution: 'حل بواسطة المسؤول',
    },
    transactions: {
        pageTitle: ' المعاملات (منذ آخر تسوية) ',
        outstandingBalance: 'المبلغ المستحق',
        emptyState: 'لا يوجد معاملات دفع حتى الآن',
        settle: 'تسوية',
        branchName: 'اسم الفرع',
        appointmentNumber: 'رقم الحجز',
        paymentType: 'نوع المعاملة',
        date:'تاريخ',
        paidAmount: 'المبلغ المدفوع',
        settlementAmount:'مبلغ التسوية',
        sr: 'ريال سعودي',
        settlementConfirmation: 'تأكيد التسوية',
        serviceProvider: 'مقدة الخدمة',
        settlementStatus: 'حالة التسوية',
    },
    fixedCommissionFees: {
        pageTitle: 'رسوم العمولة الثابتة',
        emptyState: 'لا يوجد رسوم عمولة ثابتة حتى الآن',
        month: 'شهر',
        amount: 'المبلغ'
    },
    settlements: {
        pageTitle:'التسويات السابقة',
        emptyState: 'لا يوجد تسويات حتى الآن',
        date: 'التاريخ',
        time: 'الوقت',
        status: 'الحالة',
        startDate: 'تاريخ البداية',
        endDate: 'تاريخ النهاية',
        settlementAmount: 'مبلغ التسوية',
        exportTransactions: ' تحميل المعاملات',
        exportSettlements: 'تحميل التسويات'
    }
};

export default outStandingBalance;